import React from "react"
import * as styles from "./Header-tw-styles"
import Link from "../../UI/Link/Link"
import MenuElements from "./MenuElements"
import { HeaderPropTypes } from "./propTypes"
import { gaEventClasses, gaEventLabels } from "../../../constants/gtm.constants"

function HeaderDesktop(props) {
    const { logo, menuElementsCollection, mainCta } = props
    const style = styles.desktopStyles

    return (
        <>
            <header className={`${style.header}`}>
                <div className={style.borderBottom}>&nbsp;</div>
                <div className={style.wrapper}>
                    <div className={style.logoWrapper}>
                        <Link
                            url={`/`}
                            gaEventClass={gaEventClasses.headerLogo}
                            gaEventLabel = {gaEventLabels.headerLogo}
                        >
                            <img
                                src={logo.url}
                                width={logo.width}
                                height={logo.height}
                                alt={logo.title}
                                loading="eager"
                            />
                        </Link>
                    </div>
                    <div className={style.desktopContent}>
                        <MenuElements items={menuElementsCollection.items} style={style} />
                        <div className={style.mainCtaWrapper}>
                            <Link {...mainCta} />
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default HeaderDesktop

HeaderDesktop.propTypes = HeaderPropTypes
